import React, { useEffect, useState } from 'react';
import { Button, FormControl, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faPencil,
	faFloppyDisk,
	faTrash
} from '@fortawesome/free-solid-svg-icons';
import Cookies from 'js-cookie';

import s from './TodoList.module.css';
import circle from '../images/circle-regular.png';
import circle2 from '../images/circle-check.png';

function TodoList({ todo, setTodo }) {
	const [edit, setEdit] = useState(null);
	const [value, setValue] = useState('');
	const [filtered, setFiltered] = useState(todo);

	useEffect(() => {
		// Загрузка сохраненных задач из cookies
		const savedTodo = Cookies.get('todo');
		if (savedTodo) {
			setTodo(JSON.parse(savedTodo));
		}
	}, []);

	function saveTodoToCookies(newTodo) {
		// Сохранение задач в cookies
		Cookies.set('todo', JSON.stringify(newTodo));
	}

	function todoFilter(status) {
		if (status === 'all') {
			// Отображение всех задач
			setFiltered(todo);
		} else {
			// Фильтрация задач по статусу
			const newTodo = todo.filter((item) => item.status === status);
			setFiltered(newTodo);
		}
	}

	useEffect(() => {
		// Обновление списка задач при изменении
		setFiltered(todo);
	}, [todo]);

	function deleteTodo(id) {
		// Удаление задачи
		const newTodo = todo.filter((item) => item.id !== id);
		setTodo(newTodo);
		saveTodoToCookies(newTodo);
	}

	function toggleStatus(id) {
		// Изменение статуса задачи (открыть/закрыть)
		const newTodo = todo.map((item) => {
			if (item.id === id) {
				item.status = !item.status;
			}
			return item;
		});
		setTodo(newTodo);
		saveTodoToCookies(newTodo);
	}

	function startEditing(id, title) {
		// Начало редактирования задачи
		setEdit(id);
		setValue(title);
	}

	function saveEditedTodo(id) {
		// Сохранение отредактированной задачи
		const newTodo = todo.map((item) => {
			if (item.id === id) {
				item.title = value;
			}
			return item;
		});
		setTodo(newTodo);
		setEdit(null);
		saveTodoToCookies(newTodo);
	}

	return (
		<div className={s.body}>
			<Row>
				<Col className={s.filter}>
					<div class="btn-group" role="group">
						<input
							type="radio"
							class="btn-check"
							name="vbtn-radio"
							id="vbtn-radio1"
							autocomplete="off"
						/>
						<label
							onClick={() => todoFilter('all')}
							class="btn btn-outline-light"
							for="vbtn-radio1"
						>
							Все
						</label>
						<input
							type="radio"
							class="btn-check"
							name="vbtn-radio"
							id="vbtn-radio2"
							autocomplete="off"
						/>
						<label
							onClick={() => todoFilter(true)}
							class="btn btn-outline-light"
							for="vbtn-radio2"
						>
							Открытые
						</label>
						<input
							type="radio"
							class="btn-check"
							name="vbtn-radio"
							id="vbtn-radio3"
							autocomplete="off"
						/>
						<label
							onClick={() => todoFilter(false)}
							class="btn btn-outline-light"
							for="vbtn-radio3"
						>
							Закрытые
						</label>
					</div>
					<p class="text-light">Отфильтруйте задачи*</p>
				</Col>
			</Row>

			{filtered.map((item) => (
				<div key={item.id} className={s.listItems}>
					{edit === item.id ? (
						<div>
							<FormControl
								type="text"
								value={value}
								onChange={(e) =>
									setValue(e.target.value)
								}
							/>
						</div>
					) : (
						<div className={item.status ? '' : s.close}>
							<button
								className={s.btn2}
								onClick={() =>
									toggleStatus(item.id)
								}
							>
								{item.status ? (
									<img
										alt="circle"
										width="20px"
										src={circle}
									/>
								) : (
									<img
										alt="circle2"
										width="20px"
										src={circle2}
									/>
								)}
							</button>

							<span className={s.title}>
								{item.title}
							</span>
						</div>
					)}

					{edit === item.id ? (
						<div>
							<Button
								className={s.btn}
								onClick={() =>
									saveEditedTodo(item.id)
								}
							>
								<FontAwesomeIcon
									icon={faFloppyDisk}
								/>
							</Button>
						</div>
					) : (
						<div>
							<Button
								className={s.btn}
								variant="danger"
								onClick={() =>
									deleteTodo(item.id)
								}
							>
								<FontAwesomeIcon
									icon={faTrash}
								/>
							</Button>
							<Button
								className={s.btn}
								onClick={() =>
									startEditing(
										item.id,
										item.title
									)
								}
							>
								<FontAwesomeIcon
									icon={faPencil}
								/>
							</Button>
						</div>
					)}
				</div>
			))}
		</div>
	);
}

export default TodoList;
